var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text?_vm.text:'儲存草稿'))])
}
var staticRenderFns = []

export { render, staticRenderFns }